import {
    Box,
    Button,
    CircularProgress,
    TextField,
    useTheme,
} from "@mui/material";
import { ChangeEvent, FormEvent, useContext, useEffect, useState } from "react";

import { Global_CTX } from "../../contexts/global-ctx";
import {
    INew_Org,
    Organization_Service,
    Organization_Status,
} from "../../services/organization/organization-service";
import { Add } from "@mui/icons-material";
import { Autocomplete } from "../Autocomplete/Autocomplete";
import { INITIAL_FEEDBACK } from "../../utils/constants";
// import New_Feedback from "../feedback";

const initial_organization: INew_Org = {
    name: "",
    code: "",
    status: Organization_Status.Active,
};

export default function Create_Org_Form() {
    const [organization, set_organization] = useState(initial_organization);
    const { feedback, set_feedback, set_refetch_counter } =
        useContext(Global_CTX);
    const theme = useTheme();

    const handle_change = (ev: ChangeEvent<HTMLInputElement>) => {
        const value = ev.target.value;
        set_organization({
            ...organization,
            [ev.target.name]: value,
        });
    };

    const handle_submit = async (ev: FormEvent) => {
        ev.preventDefault();

        set_feedback({ ...feedback, loading: true });

        const [data, error] =
            await Organization_Service.getInstance().create_org(organization);

        if (error) {
            set_feedback({
                loading: false,
                message: { title: error.message },
                severity: "error",
                show: true,
            });
            return;
        }

        if (data) {
            set_feedback({
                loading: false,
                message: { title: data.message },
                severity: "success",
                show: true,
            });

            set_refetch_counter((n) => n + 1);
        }
    };

    return (
        <form
            onSubmit={handle_submit}
            style={{
                // width: 360,
                // padding: theme.spacing(2),
                display: "flex",
                // flexDirection: "column",
                gap: theme.spacing(2),
            }}
        >
            <TextField
                label="Name"
                fullWidth
                value={organization.name}
                name="name"
                onChange={handle_change}
                sx={{ flex: 1 }}
                required
            />

            <TextField
                label="Organization Code"
                // multiline
                // minRows={3}
                fullWidth
                value={organization.code}
                name="code"
                onChange={handle_change}
                sx={{ flex: 1 }}
                required
            />

            <Box sx={{ flex: 1 }}>
                <Autocomplete
                    defaultOptions={Object.entries(Organization_Status).map(
                        ([label, id]) => ({ label, id })
                    )}
                    labelKey="label"
                    setOutput={(val) => {
                        set_organization((curr) => ({
                            ...curr,
                            status: val || curr.status,
                        }));
                    }}
                    label="Status"
                    textFieldProps={{ required: true }}
                />
            </Box>

            <Button
                type="submit"
                variant="contained"
                disabled={feedback.loading}
                startIcon={
                    feedback.loading ? <CircularProgress size="1em" /> : <Add />
                }
            >
                {feedback.loading
                    ? "Creating Organization..."
                    : "Create Organization"}

                {/* {!updateMode
              ? feedback.loading
                ? "Adding session..."
                : "Add session"
              : feedback.loading
                ? "updating session..."
                : "update session"} */}
            </Button>

            {/* <New_Feedback /> */}
        </form>
    );
}
